import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { of, Observable, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService, TypeMessage } from 'src/core/services/notification.service';
import { Visiteurs } from 'src/modules/visiteurs/state/visiteurs.actions';
import { getBlobFromImageElement, copyBlobToClipboard } from 'copy-image-clipboard'
import { TranslateService } from '@ngx-translate/core';
import { confirm } from 'devextreme/ui/dialog';
import { FormulairesService } from 'src/api/services';
import { DownloadService } from 'src/core/services/downloadService';

@Component({
  selector: 'app-qr-codes-barres',
  templateUrl: './qr-codes-barres.component.html',
  styleUrls: ['./qr-codes-barres.component.scss']
})
export class QrCodesBarresComponent implements OnInit {

  @Input() disabled: boolean = false;
  @Input() public personne: any;

  constructor(private store: Store,
    private translate: TranslateService,
    private notificationService: NotificationService,
    private downloadService: DownloadService,
    private formulairesService: FormulairesService
    ) { }

  ngOnInit() {
  }

  create() {
    const message = this.translate.instant('Dialog.GenerateConfirmQuestion');
    const title = this.translate.instant('Dialog.GenerateConfirm');
    const result = confirm(message, title);

    result.then(dialogResult => {
      if (dialogResult === true) {
        if(this.personne.Type != undefined) {
          // Etranger
          this.store.dispatch(new Visiteurs.CreateEtrangerCodes(this.personne.Id)).subscribe(res => {
            if(res.visiteurs.error == null) {
              this.notificationService.displayMessage(TypeMessage.success, this.translate.instant('Notification.CreateCodesSuccess'));
            } else {
              this.notificationService.displayMessage(TypeMessage.error, this.translate.instant('Notification.CreateCodesError'));
            }
          });
        } else {
          // PM
          this.store.dispatch(new Visiteurs.CreatePMCodes(this.personne.Id)).subscribe(res => {
            if(res.visiteurs.error == null) {
              this.notificationService.displayMessage(TypeMessage.success, this.translate.instant('Notification.CreateCodesSuccess'));
            } else {
              this.notificationService.displayMessage(TypeMessage.error, this.translate.instant('Notification.CreateCodesError'));
            }
          });
        }
      }
    });
  }

  download() {
    if(this.personne.Type != undefined) {
      // Etranger
      this.formulairesService.formulaireGetCodesAccesVisiteurPp({ personnePhysiqueId: this.personne.Id }).pipe(
        tap(res => {
          this.downloadService.DownloadBlob(res, 'application/pdf', 'Codes d\'accès visiteur - Personne physique.pdf');
        }),
        catchError((error: HttpErrorResponse) => {
          return of(error);
        })
      ).subscribe();
    } else {
      // PM
      this.formulairesService.formulaireGetCodesAccesVisiteurPm({ personneMoraleId: this.personne.Id }).pipe(
        tap(res => {
          this.downloadService.DownloadBlob(res, 'application/pdf', 'Codes d\'accès visiteur - Personne morale.pdf');
        }),
        catchError((error: HttpErrorResponse) => {
          return of(error);
        })
      ).subscribe();      
    }
  }

  print() {
    if (this.personne.Type != undefined) {
      // Etranger
      this.formulairesService.formulairePrintCodesAccesVisiteurPp({ personnePhysiqueId: this.personne.Id }).pipe(
        tap(res => {
          // notification ?
        }),
        catchError((error: HttpErrorResponse) => {
          return of(error);
        })
      ).subscribe();
    } else {
      // PM
      this.formulairesService.formulairePrintCodesAccesVisiteurPm({ personneMoraleId: this.personne.Id }).pipe(
        tap(res => {
          // notification ?
        }),
        catchError((error: HttpErrorResponse) => {
          return of(error);
        })
      ).subscribe();      
    }
  }

  copyElement(imageElement, isBarcode: boolean) {
    getBlobFromImageElement(imageElement).then((blob) => {
      return copyBlobToClipboard(blob)
    }).then(() => {
      if(isBarcode) {
        this.notificationService.displayMessage(TypeMessage.success, this.translate.instant('Notification.CopySuccessBarcode'));
      } else {
        this.notificationService.displayMessage(TypeMessage.success, this.translate.instant('Notification.CopySuccessQR'));
      }
    })
    .catch((e) => {
      if(isBarcode) {
        this.notificationService.displayMessage(TypeMessage.success, this.translate.instant('Notification.CopyErrorBarcode'));
      } else {
        this.notificationService.displayMessage(TypeMessage.success, this.translate.instant('Notification.CopyErrorQR'));
      }
    })
  }

  copyBarcode() {
    let imageElement = (document.getElementById('pbarcode').firstChild as ChildNode).firstChild as HTMLImageElement;
    this.copyElement(imageElement, true);
  }

  copyQRCode() {
    let imageElement = (document.getElementById('pqrcode').firstChild as ChildNode).firstChild as HTMLImageElement;
    this.copyElement(imageElement, false);
  }
}
